import { useContext } from "react";
import { GlobalContext } from "../util/globalContext";

export function useOrderApi() {
const { config } = useContext(GlobalContext);
const BASE_URL = config?.REACT_APP_BASE_URL || "http://localhost:3000"

// ✅ Helper to include token in headers
function getAuthHeaders() {
  const token = localStorage.getItem("token");
  return {
    "Content-Type": "application/json",
    "X-token": token || "",
  };
}

// ✅ Get all vendor orders
async function getAllVendorOrders({
  limit = 10,
  offset = 0,
  deviceIds = [],
  toOrgId = [],
  status = [],
  search = "",
  fromDate = "",  // ✅ Add fromDate
  toDate = "",    // ✅ Add toDate
}) {
  const payload = { limit, offset };

  // Add filters if they exist
  if (deviceIds.length > 0) payload.deviceIds = deviceIds;
  if (Array.isArray(toOrgId) && toOrgId.length > 0) payload.toOrgId = toOrgId;
  if (Array.isArray(status) && status.length > 0) payload.status = status;
  if (search) payload.search = search;
  if (fromDate) payload.fromDate = fromDate;
  if (toDate) payload.toDate = toDate;

  try {
    const response = await fetch(`${BASE_URL}/get_all_orders`, {
      method: "POST",
      headers: getAuthHeaders(),
      body: JSON.stringify(payload),
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to fetch orders");
    }

    return data;
  } catch (err) {
    console.error("Error fetching vendor orders:", err);
    throw err;
  }
}

// ✅ Create order with devices
async function createOrderWithDevices(orderData) {
  const response = await fetch(`${BASE_URL}/create_order_with_devices`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(orderData),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to create order");
  return data; // { success, message, data: { order, devices, skippedDevices } }
}

// ✅ Delete a vendor device by ID
async function deleteVendorDevice(deviceId) {
  const response = await fetch(`${BASE_URL}/delete_vendor_device/${deviceId}`, {
    method: "DELETE",
    headers: getAuthHeaders(),
  });

  const data = await response.json();
  if (!response.ok || !data.success) throw new Error(data.message || "Failed to delete device");
  return data; // { success, message }
}

// ✅ Get dashboard details for current user (POST) with optional date filters
async function getDashboard({ fromDate, toDate } = {}) {
  const payload = {
    fromTime: fromDate, // e.g., "2025-09-26"
    toTime: toDate,     // e.g., "2025-09-26"
  };

  const response = await fetch(`${BASE_URL}/get_dashboard`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify(payload),
  });

  const data = await response.json();

  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to fetch dashboard details");
  }

  return data; // { success, message, data: {...} }
}

// ✅ Update order status
async function updateOrderStatus({ orderId, status }) {
  debugger
  const response = await fetch(`${BASE_URL}/update_order_status`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ orderId, status }), // only send orderId and new status
  });

  const data = await response.json();
  if (!response.ok || !data.success) {
    throw new Error(data.message || "Failed to update order status");
  }

  return data; // { success, message }
}

  // ✅ Delete order by ID (Inventory Logs delete)
  async function deleteOrder(orderId) {
    const response = await fetch(`${BASE_URL}/delete_order/${orderId}`, {
      method: "DELETE",
      headers: getAuthHeaders(),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Failed to delete order");
    }

    return data; // { success, message }
  }

 // ✅ RETURN ALL FUNCTIONS
  return {
    getAllVendorOrders,
    createOrderWithDevices,
    deleteVendorDevice,
    getDashboard,
    updateOrderStatus,
    deleteOrder
  };
}